var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 19.5V14.25C2.75235 13.4551 3.06917 12.6934 3.63128 12.1313C4.19338 11.5692 4.95507 11.2523 5.75 11.25H19.25C20.0449 11.2523 20.8066 11.5692 21.3687 12.1313C21.9308 12.6934 22.2477 13.4551 22.25 14.25V19.5M18.5 11.25H5V6.375C5.00148 5.87818 5.1995 5.40212 5.55081 5.05081C5.90212 4.6995 6.37818 4.50148 6.875 4.5H18.125C18.6218 4.50148 19.0979 4.6995 19.4492 5.05081C19.8005 5.40212 19.9985 5.87818 20 6.375V11.25H18.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 19.5V19.125C2.75087 18.8269 2.86967 18.5413 3.08046 18.3305C3.29125 18.1197 3.5769 18.0009 3.875 18H21.125C21.4231 18.0009 21.7087 18.1197 21.9195 18.3305C22.1303 18.5413 22.2491 18.8269 22.25 19.125V19.5M5.75 11.25V10.5C5.75111 10.1025 5.90951 9.72163 6.19057 9.44057C6.47163 9.15951 6.85252 9.00111 7.25 9H11C11.3975 9.00111 11.7784 9.15951 12.0594 9.44057C12.3405 9.72163 12.4989 10.1025 12.5 10.5M12.5 10.5V11.25M12.5 10.5C12.5011 10.1025 12.6595 9.72163 12.9406 9.44057C13.2216 9.15951 13.6025 9.00111 14 9H17.75C18.1475 9.00111 18.5284 9.15951 18.8094 9.44057C19.0905 9.72163 19.2489 10.1025 19.25 10.5V11.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.8ec56cd8241c8bb3bb6201191f293d64.svg";
export { ForwardRef as ReactComponent };